import React from 'react';
import { format } from 'date-fns';
import { FavoriteButton } from 'components/favorite-button';
import { LivePreMessage } from 'components/live-pre-message';
import LeaderboardWidgetFavoriteRow from './leaderboard-widget-favorite-row';
import LeaderboardWidgetFavoriteRowTitle from './leaderboard-widget-favorite-row-title';
import LeaderboardWidgetFavoriteFooter from './leaderboard-widget-favorite-footer';
import { noFavoriteMessage } from './enums';

const LeaderboardWidgetFavorite = ({
    numberOfCells,
    scoringLeaderboard,
    liveScanner,
    topPlayersToShowState,
    datePublished,
    titleText,
    favoriteTitleText,
    players,
    fullLeaderboardLinkText,
    fullLeaderboardLink,
    targetsConfig,
    patronLogo,
    liveComponentLeaderboard,
    liveComponentSubtitle,
    stateFavoriteButton,
    onClick,
}) => {
    const hasNoPlayers = stateFavoriteButton && players.length === 0;

    let content;

    if (!liveComponentLeaderboard) {
        content = (
            <div className="leaderboard-widget-favorite__holding-message">
                {liveComponentSubtitle}
            </div>
        );
    } else if (hasNoPlayers) {
        content = (
            <LivePreMessage model={noFavoriteMessage} />
        );
    } else {
        content = (
            <div className={`leaderboard-widget-favorite__table ${stateFavoriteButton ? 'is-favourite' : ''}`}>
                {datePublished && (
                    <div className="leaderboard-widget-favorite__pubdate-content">
                        <time className="leaderboard-widget-favorite__pubdate">
                            {format(datePublished, 'h:mm a')}
                        </time>
                    </div>
                )}
                <LeaderboardWidgetFavoriteRowTitle
                    numberOfCells={numberOfCells}
                    topPlayersToShowState={topPlayersToShowState}
                    titleText={titleText}
                />
                <div className="leaderboard-widget-favorite__scroll">
                    {players.map((player) => (
                        <LeaderboardWidgetFavoriteRow
                            key={player.id}
                            scoringLeaderboard={scoringLeaderboard}
                            player={player}
                            numberOfCells={numberOfCells}
                            targetsConfig={targetsConfig}
                            liveScanner={liveScanner}
                            stateFavoriteButton={stateFavoriteButton}
                        />
                    ))}
                </div>
                <LeaderboardWidgetFavoriteFooter
                    fullLeaderboardLinkText={fullLeaderboardLinkText}
                    fullLeaderboardLink={fullLeaderboardLink}
                    targetsConfig={targetsConfig}
                    patronLogo={patronLogo}
                />
            </div>
        );
    }

    return (
        <div className="leaderboard-widget-favorite__layout">
            <div className="leaderboard-widget-favorite__headline">
                <div className="leaderboard-widget-favorite__title-text">
                    {stateFavoriteButton ? favoriteTitleText : titleText}
                </div>
                <FavoriteButton
                    childCss="leaderboard__favourites"
                    stateFavoriteButton={stateFavoriteButton}
                    onClick={onClick}
                />
            </div>
            {content}
        </div>
    );
};

export default LeaderboardWidgetFavorite;
